import React from "react";
import DateTime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import autoBind from "react-autobind";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";

const DATE_FORMAT = "YYYY-MM-DD";
const TIME_FORMAT = "HH:mm";

class PlayerDatePicker extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;

		const item = this.props.item;

		autoBind(this);

		const value = this.getFormattedValue(item.value, item);

		this.state = {
			value: value
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.item.value !== this.props.item.value) {
			this.setState({ value: this.getFormattedValue(nextProps.item.value, nextProps.item) });
		}
	}

	getFormatFromItem(item) {
		let format;

		if (item.type.toLowerCase() === "itemdate") {
			format = DATE_FORMAT;
		} else if (item.type.toLowerCase() === "itemdatetime") {
			format = DATE_FORMAT + " " + TIME_FORMAT;
		} else {
			format = TIME_FORMAT;
		}
		return format;
	}

	getFormattedValue(value, item) {
		let formattedValue;
		if (!_.isUndefined(value)) {
			const format = this.getFormatFromItem(item);

			if (value === "today") {
				formattedValue = moment().format(format);
			} else {
				if (value.format) {
					formattedValue = value.format(format);
				} else {
					formattedValue = moment(value, format).format(format);
				}
			}
		}
		return formattedValue;
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value); }
	}

	onBlur(value) {
		const formattedDate = this.getFormattedValue(value, this.props.item);
		if (this.props.onChange) { this.props.onChange(formattedDate); }
	}

	onChange(value) {
		const formattedDate = this.getFormattedValue(value, this.props.item);
		this.setState({ value: formattedDate });
	}

	triggerOnChange() {
		if (this.props.onChange) { this.props.onChange(this.state.value); }
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {

		const { item, getImage, getVideo, getPdf } = this.props;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;


		const datePickerTheme = _.get(theme, "item.datePicker", {});
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "auto" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div style={datePickerTheme}>
						{this.state.value}
					</div>
				</div>
			</div>
		);
	}

	renderEditable() {
		const { item, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex, disabled } = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;

		const timeConstraints = {
			minutes: {
				step: 1
			}
		};

		let dateFormat;
		let timeFormat;

		if (item.type.toLowerCase() === "itemdate") {
			dateFormat = DATE_FORMAT;
			timeFormat = false;
		} else if (item.type.toLowerCase() === "itemdatetime") {
			dateFormat = DATE_FORMAT;
			timeFormat = TIME_FORMAT;
		} else {
			dateFormat = false;
			timeFormat = TIME_FORMAT;
		}
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const datePickerTheme = _.get(theme, "item.datePicker", {});
		const datePickerStyles = _.assign({ marginBottom: "12px" }, datePickerTheme);
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div style={datePickerStyles}>
						<DateTime dateFormat={dateFormat} timeFormat={timeFormat} timeConstraints={timeConstraints} value={this.state.value} onChange={this.onChange} onBlur={this.onBlur} inputProps={{
							disabled,
							style:datePickerStyles
						}} />
					</div>
					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>
		);
	}
}

export default withPlayerItemHoc(PlayerDatePicker);